import {Observable}                              from 'rxjs';
import {distinctUntilChanged, filter, map, skip} from 'rxjs/operators';

import Volume from '../../Volume/Volume';

const createVolumeLevelWriteStream = (
    volumeUpdate$: Observable<Volume>
): Observable<number> =>
    volumeUpdate$
        .pipe(
            // Ignore the "default" emission from the volume store
            skip(1),
            filter(({isSliderActive}) => !isSliderActive),
            map(({level}) => level),
            distinctUntilChanged()
        );

export default createVolumeLevelWriteStream;
